import { render } from "./PrivilegeReportsPage.vue?vue&type=template&id=55bb49cf&scoped=true"
import script from "./PrivilegeReportsPage.vue?vue&type=script&lang=js"
export * from "./PrivilegeReportsPage.vue?vue&type=script&lang=js"

import "./PrivilegeReportsPage.vue?vue&type=style&index=0&id=55bb49cf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bb49cf"]])

export default __exports__